import i18next from "i18next";

/**
 * Format given string using i18next.
 * @param wordToFormat Word to format
 * @param formatType format to apply: 'capitalize, 'uppercase' or 'title'
 */
export const formatWord = (wordToFormat: string, formatType: "capitalize" | "uppercase" | "title" | "camelCase") =>
	i18next.format(wordToFormat, formatType);
